export enum INTERVENTION_APPOINTMENT_ACTION_TYPES {
  SELECT_TIMESLOT = 'SELECT_TIMESLOT',
  SET_ERRORS = 'SET_ERRORS',
  VALIDATE_TIMESLOT = 'VALIDATE_TIMESLOT',
  RESET_CALENDAR = 'RESET_CALENDAR',
  PAGE_NUMBER_CHANGE = 'PAGE_NUMBER_CHANGE',
}
